<template>
  <a-row>
    <a-col :span="24">
      <div class="flex items-center justify-end">
        <cds-button
          v-if="permissions.hasReset"
          class="mt-1 ml-10 mr-10 sDash_form-action__btn"
          html-type="button"
          type="light"
          size="small"
          @click="emitEvent('onClear')"
        >
          Đặt lại
        </cds-button>
        <cds-button
          v-if="permissions.hasSearch"
          class="mt-1 ml-10 mr-10 sDash_form-action__btn"
          type="primary"
          size="small"
          @click="emitEvent('onSearch')"
        >
          Tìm kiếm
        </cds-button>
        <cds-button
          v-if="permissions.hasCreate"
          class="mt-1 ml-10 mr-10 sDash_form-action__btn"
          type="primary"
          size="small"
          @click="emitEvent('onCreate')"
        >
          Thêm mới
        </cds-button>
        <cds-button
          v-if="permissions.hasCreateMenu"
          class="mt-1 mr-10 sDash_form-action__btn"
          type="primary"
          size="small"
          @click="emitEvent('onCreateMenu')"
        >
          Thêm mới menu
        </cds-button>
        <cds-button
          v-if="permissions.hasCreateButton"
          class="mt-1 mr-10 sDash_form-action__btn"
          type="primary"
          size="small"
          @click="emitEvent('onCreateButton')"
        >
          Thêm mới nút
        </cds-button>
        <cds-button
          v-if="permissions.hasExportExcel"
          class="mt-1 mr-10 sDash_form-action__btn"
          type="primary"
          size="small"
          @click="emitEvent('onExportExcel')"
        >
          Xuất Excel
        </cds-button>
        <cds-button
          v-if="permissions.hasApproval"
          class="mt-1 mr-10 sDash_form-action__btn"
          type="primary"
          size="small"
          @click="emitEvent('onApproval')"
        >
          Duyệt
        </cds-button>
        <cds-button
          v-if="permissions.hasCancelApproval"
          class="mt-1 mr-10 sDash_form-action__btn"
          type="danger"
          size="small"
          @click="emitEvent('onCancelApproval')"
        >
          Bỏ duyệt
        </cds-button>
        <cds-button
          v-if="permissions.hasDelete"
          class="mt-1 ml-10 mr-10 sDash_form-action__btn"
          type="primary"
          outlined
          size="small"
          @click="emitEvent('onDelete')"
        >
          Xoá
        </cds-button>
        <cds-button
          v-if="permissions.hasUnPublic"
          class="mt-1 ml-10 mr-10 sDash_form-action__btn"
          type="primary"
          outlined
          size="small"
          @click="emitEvent('onUnPublic')"
        >
          Gỡ bài
        </cds-button>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import VueTypes from 'vue-types';
import { computed, defineComponent, watch, ref, onMounted } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'SearchFormButton',
  props: {
    buttons: VueTypes.array.def([]),
  },
  setup(props, { emit }) {
    const emitEvent = (event) => {
      emit(event);
    };
    const { state } = useStore();
    const perms = computed(() => state.auth.userInfo.permissions);
    const hasButton = (button) =>
      (props.buttons || []).some(
        (e) =>
          e.type === button &&
          (!e.permission || (perms.value || []).includes(e.permission))
      );
    const permissions = ref({
      hasReset: false,
      hasSearch: false,
      hasCreate: false,
      hasCreateMenu: false,
      hasCreateButton: false,
      hasDelete: false,
      hasApproval: false,
      hasCancelApproval: false,
      hasExportExcel: false,
      hasUnPublic: false,
    });
    const fetchPerm = () => {
      permissions.value = {
        hasReset: hasButton('RESET'),
        hasSearch: hasButton('SEARCH'),
        hasCreate: hasButton('CREATE'),
        hasCreateMenu: hasButton('CREATE_MENU'),
        hasCreateButton: hasButton('CREATE_BUTTON'),
        hasDelete: hasButton('DELETE'),
        hasApproval: hasButton('APPROVAL'),
        hasCancelApproval: hasButton('CANCEL_APPROVAL'),
        hasExportExcel: hasButton('EXPORT_EXCEL'),
        hasUnPublic: hasButton('UN_PUBLISH'),
      };
    };
    watch(() => perms.value, fetchPerm);
    onMounted(fetchPerm);
    return {
      emitEvent,
      permissions,
    };
  },
});
</script>

<style lang="scss" scoped>
.sDash_form-action {
  &__btn {
    @apply uppercase;
  }
}
</style>
